import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9 9a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2zM13 13a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2zM17 18a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 24h4.323l1.749 4.371a1 1 0 0 0 1.857-.742L23.477 24H30a1 1 0 1 0 0-2h-1V6.059C29 4.976 28.158 4 27 4H5c-1.158 0-2 .976-2 2.059V22H2a1 1 0 1 0 0 2h6.523l-1.451 3.629a1 1 0 1 0 1.856.742L10.679 24H15v4a1 1 0 1 0 2 0zM5 6.059c0-.03.01-.05.017-.059h21.966c.007.01.017.028.017.059V21.94c0 .03-.01.05-.017.059H5.018A.1.1 0 0 1 5 21.941z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconProjectManagement = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconProjectManagement);
export default Memo;
